// extracted by mini-css-extract-plugin
export default {"productGallery":"IN-z","inQuickShop":"JN-z"};